import {
  PARENT_ROLES,
  PRIVILEGES,
  SUB_ROLES,
  REPORTS,
} from "../../utility/TextLabels";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

interface SidebarItemProps {
  primary: string;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ primary }) => {
  return (
    <ListItem
      disablePadding
      component={Link}
      to={`/${primary.toLowerCase()}`}
      sx={{ paddingBottom: "10px" }}
    >
      <ListItemIcon sx={{ minWidth: "auto", marginRight: "8px" }}>
        <ArrowForwardRoundedIcon
          htmlColor="#755FFA"
          sx={{ width: "12px", height: "12px" }}
        />
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography
            color="black"
            fontFamily="Lato"
            fontSize="16px"
            fontStyle="normal"
            fontWeight={400}
            lineHeight="normal"
          >
            {primary}
          </Typography>
        }
      />
    </ListItem>
  );
};

const Sidebar = () => {
  return (
    <List disablePadding sx={{ marginTop: "20px", marginLeft: "40px" }}>
      <SidebarItem primary={PRIVILEGES} />
      <SidebarItem primary={PARENT_ROLES} />
      <SidebarItem primary={SUB_ROLES} />
      <SidebarItem primary={REPORTS} />
    </List>
  );
};

export default Sidebar;
